import { useState, useEffect, useContext } from "react";
import { Data } from "./types/TypeData";
import { DataJudge } from "./DataJudge";
import { DataContextProvider, LikeButtonFlagContextProvider, ModalContext, RenderContext } from './CreateContext';
import { ModalContextProvider } from "./CreateContext";
import { UrgentDeliver } from "./UrgentDelivery";
import "../css/spinner.scss"

// ホスト名生成
export const Apihost = () => {
  const api_version = "v2"
  const hostname = window.location.hostname;
  let fullURL = window.location.href;
  // クエリパラメータを削除
  const queryIndex = fullURL.indexOf('?');
  if (queryIndex !== -1) {
    fullURL = fullURL.substring(0, queryIndex);
  }
  if (hostname === "localhost" || hostname === "10.48.5.3") {
    return `/api/${api_version}/wall`
  } else {
    return `${fullURL?.replace(/-signage|-wall/g, "-api")}api/${api_version}/wall`;
  }
}

export const DataGet = () => {
  const [data, setData] = useState<{ fixed: Data[], move: Data[] }>({ fixed: [], move: [] });
  const { setRerender, rerender, setSettings } = useContext(RenderContext);
  const [loading, setLoading] = useState(false);

  // cursorがtrueかどうか調べる
  const searchParams = new URLSearchParams(window.location.search);
  const cursor = searchParams.get('cursor');

  // 右クリックを禁止する
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  // ドラッグを禁止する
  const handleDragStart = (e: React.DragEvent) => {
    e.preventDefault();
  };

  useEffect(() => {
    setRerender(true)
  }, [rerender])
  const apihost = Apihost()
  useEffect(() => {
    setLoading(false)

    // 設定値の取得
    if (process.env.REACT_APP_OLD_API === 'true') {
      fetch(`${apihost}/get-ks-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 'x-api-key': 'DONT_PANIC'
        }, body: JSON.stringify({ "SORT_FOR_SIGNAGE": true })
      })
        .then(response => response.json())
        .then(res => {
          setSettings(res.data)
          console.log(res.data)

        }).catch(error => {
          console.log('データの取得に失敗しました', error);
        })
    } else if (process.env.REACT_APP_OLD_API === 'false') {
      fetch(`${apihost}/api/setting/get-ks-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 'x-api-key': 'DONT_PANIC'
        }, body: JSON.stringify({ "SORT_FOR_SIGNAGE": true })
      })
        .then(response => response.json())
        .then(res => {
          setSettings(res.data)
          console.log(res.data)

        }).catch(error => {
          console.log('データの取得に失敗しました', error);
        })
    } else {
      console.error('環境変数REACT_APP_OLD_APIが設定されていません')
    }


    // トピックの取得
    if (process.env.REACT_APP_OLD_API === 'true') {
      fetch(`${apihost}/get-available-topics`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 'x-api-key': 'DONT_PANIC'
        }, body: JSON.stringify({ "SORT_FOR_SIGNAGE": true })
      })
        .then(response => response.json())
        .then(res => {
          // 同じTOPIC_IDが入ってきたらそのデータをdataに入れたくない
          const ids: Set<number> = new Set();
          const moveData: Data[] = []
          const fixedData: Data[] = []
          res.data.forEach((obj: Data) => {
            if (!ids.has(obj.TOPIC_ID)) {
              obj.TOPIC_BODY = obj.TOPIC_BODY?.replace(/\\n/g, "\n");
              // 旧APIの場合、dataの中のVOTESの中にWALL_LIKESが存在し、新APIの場合、VOTESが存在せず、WALL_LIKESがdataの中に直接存在している。
              // そのため、新旧APIのデータの構造を統一するために、旧APIのデータの場合、VOTESの中のWALL_LIKESをdataの中に移動させている。
              if (obj.VOTES) {
                obj.WALL_LIKES = obj.VOTES.WALL_LIKES
              }
              ids.add(obj.TOPIC_ID);
              if (obj.CATEGORY_ID == 51) {
                fixedData.push(obj)
              } else {
                moveData.push(obj)
              }
            }
          });
          // 処理終了(TOPIC_IDが同じデータは消えています)
          // 優先配信が0枚の時、いいね数が最大のカードを固定する
          if (fixedData.length == 0) {
            let mostLikedData = moveData.reduce((maxLiked, currentData) => {
              if (currentData.WALL_LIKES > maxLiked.WALL_LIKES) {
                return currentData;
              }
              return maxLiked;
            }, moveData[0]);

            const indexToRemove = moveData.indexOf(mostLikedData);
            fixedData.push(mostLikedData)

            if (indexToRemove !== -1) {
              moveData.splice(indexToRemove, 1);
            }
          }

          //移動カードを順番に  
          const moveSortData = moveData.sort((a, b) => a.TOPIC_ID - b.TOPIC_ID)

          console.log(fixedData)
          console.log(moveSortData)
          setData({ fixed: fixedData, move: moveSortData });
        })
        .catch(error => {
          console.log('データの取得に失敗しました', error);
        })
        .finally(() => {
          setLoading(true)
        })
    }
    else if (process.env.REACT_APP_OLD_API === 'false') {
      fetch(`${apihost}/api/topic-media/get-available-topics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json', 'x-api-key': 'DONT_PANIC'
        }
      })
        .then(response => response.json())
        .then(res => {
          // 同じTOPIC_IDが入ってきたらそのデータをdataに入れたくない
          const ids: Set<number> = new Set();
          const moveData: Data[] = []
          const fixedData: Data[] = []
          res.data.forEach((obj: Data) => {
            if (!ids.has(obj.TOPIC_ID)) {
              obj.TOPIC_BODY = obj.TOPIC_BODY?.replace(/\\n/g, "\n");
              // 旧APIの場合、dataの中のVOTESの中にWALL_LIKESが存在し、新APIの場合、VOTESが存在せず、WALL_LIKESがdataの中に直接存在している。
              // そのため、新旧APIのデータの構造を統一するために、旧APIのデータの場合、VOTESの中のWALL_LIKESをdataの中に移動させている。
              if (obj.VOTES) {
                obj.WALL_LIKES = obj.VOTES.WALL_LIKES
              }
              ids.add(obj.TOPIC_ID);
              if (obj.CATEGORY_ID == 51) {
                fixedData.push(obj)
              } else {
                moveData.push(obj)
              }
            }
          });
          // 処理終了(TOPIC_IDが同じデータは消えています)
          // 優先配信が0枚の時、いいね数が最大のカードを固定する
          if (fixedData.length == 0) {
            let mostLikedData = moveData.reduce((maxLiked, currentData) => {
              if (currentData.WALL_LIKES > maxLiked.WALL_LIKES) {
                return currentData;
              }
              return maxLiked;
            }, moveData[0]);

            const indexToRemove = moveData.indexOf(mostLikedData);
            fixedData.push(mostLikedData)

            if (indexToRemove !== -1) {
              moveData.splice(indexToRemove, 1);
            }
          }

          //移動カードを順番に  
          const moveSortData = moveData.sort((a, b) => a.TOPIC_ID - b.TOPIC_ID)

          console.log(fixedData)
          console.log(moveSortData)
          setData({ fixed: fixedData, move: moveSortData });
        })
        .catch(error => {
          console.log('データの取得に失敗しました', error);
        })
        .finally(() => {
          setLoading(true)
        })
    };
  }, [rerender]);
  if (!loading) {
    return (
      <div className="App-left-component-spinner" style={{ position: "relative", width: `${window.innerWidth}px`, height: `${window.innerHeight}px` }}>
        <div className="sk-folding-cube">
          <div className="sk-cube1 sk-cube" />
          <div className="sk-cube2 sk-cube" />
          <div className="sk-cube4 sk-cube" />
          <div className="sk-cube3 sk-cube" />
        </div>
      </div>
    )
  } else if (data.fixed.length === 1 && data.fixed[0].full_screen) {
    return (
      <div
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}>
        <UrgentDeliver data={data.fixed[0]} />
      </div>
    )
  } else if (data.move.length >= 1) {
    return (
      <div
        style={{ cursor: cursor == 'true' ? 'true' : "none" }}
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}>
        <ModalContextProvider>
          <DataContextProvider>
            <LikeButtonFlagContextProvider>
              <DataJudge data={data} />
            </LikeButtonFlagContextProvider>
          </DataContextProvider>
        </ModalContextProvider>
      </div>
    )
  } else {
    return null;
  }
}